import { Rule } from 'ant-design-vue/lib/form';
import { reactive } from 'vue';
import i18n from '@/i18n/index'

const phoneStr1 = () => {
  return i18n.global.t('validate.warnStr1')
}
const phoneStr2 = () => {
  return i18n.global.t('validate.warnStr2')
}

const userStr = () => {
  return i18n.global.t('validate.warnStr3')
}

const passwordStr = () => {
  return i18n.global.t('validate.warnStr4')
}

const passwordStr2 = () => {
  return i18n.global.t('validate.warnStr9')
}

const passwordStr3 = () => {
  return i18n.global.t('validate.warnStr10')
}

const msgCodeStr1 = () => {
  return i18n.global.t('validate.warnStr5')
}

const msgCodeStr2 = () => {
  return i18n.global.t('validate.warnStr6')
}

const emailStr1 = () => {
  return i18n.global.t('validate.warnStr7')
}

const emailStr2 = () => {
  return i18n.global.t('validate.warnStr8')
}

// 手机号校验
const validatorPhone = async (_rule: Rule, value: string) => {
  if (value == '') {
    return Promise.reject(phoneStr1);
  } else if (!/^1[3456789]\d{9}$/.test(value)) {
    return Promise.reject(phoneStr2);
  } else {
    return Promise.resolve();
  }
}
// 手机号或者邮箱校验
const validatorUser = async (_rule: Rule, value: string) => {
  if (value == '') {
    return Promise.reject(emailStr1);
  } else if (!/^1[3456789]\d{9}$/.test(value) && !/^[a-z0-9]+([._\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/.test(value)) {
    return Promise.reject(emailStr2);
  } else {
    return Promise.resolve();
  }
}
export const rulesLoginRef = reactive({
  username: [
    {
      required: true,
      message: userStr,
    }
  ],
  Pwd: [
    {
      required: true,
      message: passwordStr,
    },
  ],
})

export const rulesloginPhoneRef = reactive({
  phone: [
    {
      min: 11,
      max: 11,
      message: phoneStr2,
      validator: validatorPhone,
      trigger: 'change',
    },
  ],
  msgCode: [
    {
      required: true,
      message: msgCodeStr1,
    },
    {
      min: 6,
      max: 6,
      message: msgCodeStr2,
      trigger: 'change',
    },
  ],
})
export const rulesSetPwdRef = reactive({
  newPwd: [{
    required: true,
    message: passwordStr2,
  }],
  confirmPwd: [{
    required: true,
    message: passwordStr3,
  }],
})
export const rulesForgetUser = reactive({
  username: [{
    validator: validatorUser,
    trigger: 'change',
  }]
})
export const rulesForgetPhone = reactive({
  msgCode: [
    {
      required: true,
      message: msgCodeStr1,
    },
    {
      min: 6,
      max: 6,
      message: msgCodeStr2,
      trigger: 'change',
    },
  ],
})
export const rulesVerifyEmail = reactive({
  code: [
    {
      required: true,
      message: msgCodeStr1,
    },
    {
      min: 6,
      max: 6,
      message: msgCodeStr2,
      trigger: 'change',
    },
  ],
})